import { Fragment, memo } from 'react';
import { Brand } from '../../utils/types/types';
import InfoSection from '../info-section/InfoSection';

import styles from './Title.module.scss';

type Props = {
  title: string;
  brand?: Brand;
};

const Title = ({ title, brand }: Props) => {
  if (!title && !brand) {
    return null;
  }

  return (
    <Fragment>
      <InfoSection
        className={styles.titleContainer}
        data-testid="product-title"
        border={false}
      >
        {brand ? (
          <Fragment>
            <span
              className={styles[`title--${brand.id}`]}
              data-testid="compare-brand-name"
            >
              {brand.namePrefix ? (
                <span
                  className={styles.brandPrefix}
                  data-testid="compare-brand-prefix"
                >
                  {brand.namePrefix}
                </span>
              ) : null}
              {brand.name}
            </span>
            <h2 className={styles.title}>{brand.titleWithoutBrandName}</h2>
          </Fragment>
        ) : (
          <h2 className={styles.title}>{title}</h2>
        )}
      </InfoSection>
    </Fragment>
  );
};

export default memo(Title);
